import React from "react";

const Badge = ({ children, label }) => (
  <span
    role="img"
    aria-label={label}
    title={label}
    className="inline-flex items-center justify-center h-7 w-11 rounded-md bg-white shadow-sm ring-1 ring-black/5 overflow-hidden"
  >
    {children}
  </span>
);

const Visa = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#fff" /><text x="22" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="12" fill="#1A1F71">VISA</text></svg>
);
const Mastercard = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#fff" /><circle cx="19" cy="14" r="7.5" fill="#EB001B" /><circle cx="27" cy="14" r="7.5" fill="#F79E1B" /><path d="M23 8.2a7.5 7.5 0 000 11.6 7.5 7.5 0 000-11.6z" fill="#FF5F00" /></svg>
);
const PayPal = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#fff" /><text x="22" y="18.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontStyle="italic" fontSize="9"><tspan fill="#003087">Pay</tspan><tspan fill="#009CDE">Pal</tspan></text></svg>
);
const Klarna = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#FFB3C7" /><text x="22" y="18.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="9" fill="#0B051D">Klarna.</text></svg>
);
const ApplePay = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#fff" /><g transform="translate(9,8.5)" fill="#000"><path d="M4.3 2.1c.3-.4.5-.9.4-1.4-.4 0-.9.3-1.2.6-.3.3-.5.8-.4 1.3.4 0 .9-.2 1.2-.5zM4.7 2.8c-.6 0-1.1.3-1.4.3-.3 0-.8-.3-1.3-.3-.7 0-1.3.4-1.6 1-.7 1.2-.2 3 .5 4 .3.5.7 1 1.2 1 .5 0 .7-.3 1.2-.3.5 0 .7.3 1.2.3.5 0 .8-.5 1.1-1 .4-.5.5-1 .5-1.1 0 0-1-.4-1-1.5 0-1 .8-1.4.8-1.4-.4-.7-1.1-.8-1.4-.8z" /></g><text x="30" y="18.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="9" fill="#000">Pay</text></svg>
);
const GooglePay = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#fff" /><text x="16" y="18.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="10" fill="#4285F4">G</text><text x="30" y="18.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="9" fill="#5F6368">Pay</text></svg>
);
const Sofort = () => (
  <svg viewBox="0 0 44 28" className="h-full w-full"><rect width="44" height="28" rx="4" fill="#fff" /><text x="22" y="18" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="7.5" fill="#EE7F00">SOFORT</text></svg>
);

const ITEMS = [
  ["Visa", Visa], ["Mastercard", Mastercard], ["PayPal", PayPal],
  ["Klarna", Klarna], ["Apple Pay", ApplePay], ["Google Pay", GooglePay], ["SOFORT", Sofort],
];

export default function PaymentIcons({ className = "", compact = false, testId = "payment-icons" }) {
  const items = compact ? ITEMS.slice(0, 6) : ITEMS;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={testId}>
      {items.map(([label, Icon]) => (
        <Badge key={label} label={label}><Icon /></Badge>
      ))}
    </div>
  );
}
